export default "__VITE_ASSET__7ee134bd__"